var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _path2, _rect11, _circle, _mask, _rect12, _mask2, _rect13, _mask3, _rect14, _mask4, _rect15, _mask5, _rect16, _rect17, _rect18, _rect19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSignup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 160,
    viewBox: "0 0 312 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.5,
    y: 21.5,
    width: 151,
    height: 88,
    rx: 2.5,
    fill: "white",
    stroke: "#909090"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 23.5,
    width: 147,
    height: 84,
    rx: 1.5,
    fill: "white",
    stroke: "#909090"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 164.688,
    y: 74.5,
    width: 6.5002,
    height: 6.5002,
    rx: 0.606304,
    fill: "white",
    stroke: "#13AE67"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 158.5,
    y: 80.9979,
    width: 6.5002,
    height: 6.5002,
    rx: 0.606304,
    fill: "white",
    stroke: "#13AE67"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 80.9979,
    width: 6.5002,
    height: 6.5002,
    rx: 0.606304,
    fill: "white",
    stroke: "#13AE67"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 68.498,
    width: 6.5002,
    height: 6.5002,
    rx: 0.606304,
    fill: "white",
    stroke: "#13AE67"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 158.5,
    y: 68.498,
    width: 6.5002,
    height: 6.5002,
    rx: 0.606304,
    fill: "white",
    stroke: "#13AE67"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 68,
    width: 20,
    height: 20,
    rx: 2.21261,
    stroke: "#13AE67"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 44,
    width: 20,
    height: 20,
    rx: 2.21261,
    stroke: "#13AE67"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 44,
    width: 20,
    height: 20,
    rx: 2.21261,
    stroke: "#13AE67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 109.5H95.2727L88 122.5H91.3939L104 109.5Z",
    stroke: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206 109.5H214.727L222 122.5H218.606L206 109.5Z",
    stroke: "#909090"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 202.5,
    y: 54.5,
    width: 47,
    height: 93,
    rx: 3.5,
    fill: "white",
    stroke: "#909090"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 226.5,
    cy: 60.5,
    r: 2,
    fill: "white",
    stroke: "#909090"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-1_5326_1922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.467,
    y: 105.363,
    width: 4.09102,
    height: 4.09102,
    rx: 0.603439
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 230.467,
    y: 105.363,
    width: 4.09102,
    height: 4.09102,
    rx: 0.603439,
    fill: "white",
    stroke: "#13AE67",
    strokeWidth: 2,
    mask: "url(#path-15-inside-1_5326_1922)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-2_5326_1922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.091,
    y: 108.908,
    width: 4.09102,
    height: 4.09102,
    rx: 0.603439
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 227.091,
    y: 108.908,
    width: 4.09102,
    height: 4.09102,
    rx: 0.603439,
    fill: "white",
    stroke: "#13AE67",
    strokeWidth: 2,
    mask: "url(#path-16-inside-2_5326_1922)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-3_5326_1922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.909,
    y: 108.908,
    width: 4.09102,
    height: 4.09102,
    rx: 0.603439
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 233.909,
    y: 108.908,
    width: 4.09102,
    height: 4.09102,
    rx: 0.603439,
    fill: "white",
    stroke: "#13AE67",
    strokeWidth: 2,
    mask: "url(#path-17-inside-3_5326_1922)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-4_5326_1922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.909,
    y: 102.09,
    width: 4.09102,
    height: 4.09102,
    rx: 0.603439
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 233.909,
    y: 102.09,
    width: 4.09102,
    height: 4.09102,
    rx: 0.603439,
    fill: "white",
    stroke: "#13AE67",
    strokeWidth: 2,
    mask: "url(#path-18-inside-4_5326_1922)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-5_5326_1922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.091,
    y: 102.09,
    width: 4.09102,
    height: 4.09102,
    rx: 0.603439
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 227.091,
    y: 102.09,
    width: 4.09102,
    height: 4.09102,
    rx: 0.603439,
    fill: "white",
    stroke: "#13AE67",
    strokeWidth: 2,
    mask: "url(#path-19-inside-5_5326_1922)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 102.092,
    width: 10.9091,
    height: 10.9091,
    rx: 1.20688,
    stroke: "#13AE67"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 89,
    width: 10.9091,
    height: 10.9091,
    rx: 1.20688,
    stroke: "#13AE67"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 227.091,
    y: 89,
    width: 10.9091,
    height: 10.9091,
    rx: 1.20688,
    stroke: "#13AE67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSignup1);
export default __webpack_public_path__ + "static/media/ic-signup-1.685da9357618425d9fc5790baab9b8a8.svg";
export { ForwardRef as ReactComponent };